export const categories = [
  'Barbiers',
  'Coiffeurs hommes',
  'Barbiers traditionnels',
  'Salons de barbier',
  'Barbiers à domicile',
  'Barbiers spécialisés'
];

export const features = [
  {
    icon: 'ScheduleIcon',
    title: 'Agenda intelligent',
    description: 'Gestion des rendez-vous simplifiée avec un système intelligent'
  },
  {
    icon: 'PublicIcon',
    title: 'Fiche publique référencée',
    description: 'Votre salon visible sur Google avec une fiche optimisée SEO'
  },
  {
    icon: 'QrCodeIcon',
    title: 'QR code personnalisé',
    description: 'Code QR à afficher dans votre salon pour réservations et avis'
  },
  {
    icon: 'EmailIcon',
    title: 'Rappels automatiques',
    description: 'Emails automatiques pour réduire les no-shows'
  },
  {
    icon: 'StarIcon',
    title: 'Boost SEO',
    description: 'Invitations automatiques pour collecter des avis Google'
  },
  {
    icon: 'PaymentIcon',
    title: 'Paiement sécurisé',
    description: 'Paiement en ligne et prépaiement pour vos services'
  },
  {
    icon: 'VisibilityIcon',
    title: 'Visibilité maximale',
    description: 'Présence sur BookingBarber.fr pour attirer plus de clients'
  }
];